import React, { useEffect } from "react";
import { animate, motion, useMotionValue, useTransform, useReducedMotion } from "framer-motion";

// Smoothly animates a number and renders it through a formatter.
// Respects reduced motion by snapping to the final value.
export default function AnimatedNumber({ value, formatter = (n) => String(Math.round(n)), className = "" }) {
  const reduce = useReducedMotion();
  const mv = useMotionValue(value);
  const text = useTransform(mv, (v) => formatter(v));

  useEffect(() => {
    if (reduce) {
      mv.set(value);
      return undefined;
    }
    const controls = animate(mv, value, { duration: 0.5, ease: [0.22, 1, 0.36, 1] });
    return () => controls.stop();
  }, [value, reduce, mv]);

  return <motion.span className={className}>{text}</motion.span>;
}
